import { FC } from "react"
import { css } from "@emotion/react"
import { CustomerBrandCard } from "@ncs/ncs-api"
import { Link, EventTracker, Card } from "@ncs/web-legos"
import { useAnalytics } from "~/hooks/useAnalytics"

interface ShopBrandCtaProps {
	card: CustomerBrandCard
}

export const ShopBrandCtaEcomm: FC<ShopBrandCtaProps> = ({ card }) => {
	const isExternalLink = card.buttonDestinationUrl.startsWith("http")
	const eventName = `BC_${card.name
		.replace(" - New Home Page", "")
		.trim()
		.split(" ")
		.join("_")
		.toUpperCase()}`
	const { trackEvent } = useAnalytics()

	return (
		<Card
			variant="plain"
			maxHeight={15.625}
			minHeight={8.375}
			textAlign="center"
			css={cardStyle}
		>
			<EventTracker event={eventName} trackEvent={trackEvent}>
				<Link
					to={card.buttonDestinationUrl}
					newTab={card.buttonDestinationOpensNewWindow}
					external={isExternalLink}
				>
					<img
						id={`brand-card-${card.name}`}
						src={card.logoImageUrl}
						css={logoImage}
						alt={`Logo for ${card.name}`}
						width={184}
						height={53}
						loading="lazy"
					/>
					<span css={taglineTextCss}>{card.taglineText}</span>
				</Link>
			</EventTracker>
		</Card>
	)
}

const cardStyle = css`
	text-align: center;

	img {
		display: inline-block;
	}
`

const taglineTextCss = css`
	display: block;
	font-size: 0.875rem;
	color: #1f2937;
`

const logoImage = css`
	margin-bottom: 1rem;
`
